var _style, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHandIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 65.1 65.1",
    style: {
      enableBackground: "new 0 0 65.1 65.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#231F20;stroke-width:1.5;stroke-miterlimit:10;}\r\n\t.st1{fill:#18A74A;stroke:#231F20;stroke-width:1.5;stroke-miterlimit:10;}\r\n\t.st2{fill:#231F20;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32.1,12.8l5.2-5.5c0,0,4.9-4.9,8.1-2.8c1.5,1,1.3,2.7,0.6,4.2c-0.5,1-1.4,2.2-2.5,3.5c0,0,5.1-6.5,9.1-3.7 c0,0,3.8,3.2-2.9,9.6c0,0,5.1-6.1,8.1-2c0,0,3.9,3.5-2.9,8.3c0,0,5.7-3.5,7.1,0.3c0,0,1.8,3-2.6,6.4L48.9,42.3"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 64.5,
    y1: 48,
    x2: 53.8,
    y2: 37.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 46.2,
    y1: 64.6,
    x2: 32.9,
    y2: 50.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20,64.6c0,0,9.4-12.9,16.1-16.2s9.9-4.1,9.9-4.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.9,9.5c0,0-2.5-3-5.6-0.3c0,0-3.8,2.4,0.5,7.1l8.3,8.2c0,0,2.6,2.3,5.6-0.2c0,0,2.9-2.5,0.3-5.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32,12.8l0.7,0.7c0,0,2.1,2.4-0.1,5.2c0,0-2.3,3-5.3,0.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.5,9.1c0,0-0.9-2.1,1.1-4.3c0,0,2.4-3,6.7,1l0.6,0.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M35,9.8l-2.9,3c0,0-3.1,2.3-5.9-0.1c0,0-3.5-2.1,0.4-6.4l4.8-4.4c0,0,2.9-2.3,5.6-0.1c0,0,2.6,2.8,0.1,5.8 l-2.5,2.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M21.8,25.3c1.2,2.4-0.9,4.3-0.9,4.3c-2.7,2.2-5.1,0.1-5.1,0.1l-7.6-7.4C4.3,18.1,7.8,16,7.8,16 c2.8-2.4,5.6,0.9,5.6,0.9L21.8,25.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.6,27.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.7,21.9C6.8,21,4.4,21.3,3,22.3c0,0-3.4,2,0.4,6l7.4,6.8c0,0,2.3,1.9,5-0.1c0,0,2.7-2.2,1.5-4.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M21.9,13.5L21.9,13.5c-0.3,0.3-0.8,0.3-1.1,0l-4-4c-0.3-0.3-0.3-0.8,0-1.1l0,0c0.3-0.3,0.8-0.3,1.1,0l4,4 C22.2,12.8,22.2,13.2,21.9,13.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M28.7,20.5L28.7,20.5c-0.3,0.3-0.8,0.3-1.2,0L25,18c-0.3-0.3-0.3-0.8,0-1.2h0c0.3-0.3,0.8-0.3,1.2,0l2.5,2.5 C29,19.7,29,20.2,28.7,20.5z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 0.6,
    y1: 47.9,
    x2: 11.4,
    y2: 35.9
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M565.1,644.8l5.2-5.5c0,0,4.9-4.9,8.1-2.8c1.5,1,1.3,2.7,0.6,4.2c-0.5,1-1.4,2.2-2.5,3.5c0,0,5.1-6.5,9.1-3.7 c0,0,3.8,3.2-2.9,9.6c0,0,5.1-6.1,8.1-2c0,0,3.9,3.5-2.9,8.3c0,0,5.7-3.5,7.1,0.3c0,0,1.8,3-2.6,6.4l-10.6,11.2"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 597.5,
    y1: 680,
    x2: 586.8,
    y2: 669.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 579.2,
    y1: 696.6,
    x2: 565.9,
    y2: 682.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M553,696.6c0,0,9.4-12.9,16.1-16.2c6.7-3.3,9.9-4.1,9.9-4.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M550.9,641.5c0,0-2.5-3-5.6-0.3c0,0-3.8,2.4,0.5,7.1l8.3,8.2c0,0,2.6,2.3,5.6-0.2c0,0,2.9-2.5,0.3-5.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M565,644.8l0.7,0.7c0,0,2.1,2.4-0.1,5.2c0,0-2.3,3-5.3,0.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M550.5,641.1c0,0-0.9-2.1,1.1-4.3c0,0,2.4-3,6.7,1l0.6,0.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M568,641.8l-2.9,3c0,0-3.1,2.3-5.9-0.1c0,0-3.5-2.1,0.4-6.4l4.8-4.4c0,0,2.9-2.3,5.6-0.1c0,0,2.6,2.8,0.1,5.8 l-2.5,2.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M554.8,657.3c1.2,2.4-0.9,4.3-0.9,4.3c-2.7,2.2-5.1,0.1-5.1,0.1l-7.6-7.4c-3.9-4.3-0.4-6.4-0.4-6.4 c2.8-2.4,5.6,0.9,5.6,0.9L554.8,657.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M546.6,659.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M540.7,653.9c-0.9-0.9-3.4-0.6-4.7,0.4c0,0-3.4,2,0.4,6l7.4,6.8c0,0,2.3,1.9,5-0.1c0,0,2.7-2.2,1.5-4.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M554.9,645.5L554.9,645.5c-0.3,0.3-0.8,0.3-1.1,0l-4-4c-0.3-0.3-0.3-0.8,0-1.1l0,0c0.3-0.3,0.8-0.3,1.1,0l4,4 C555.2,644.8,555.2,645.2,554.9,645.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M561.7,652.5L561.7,652.5c-0.3,0.3-0.8,0.3-1.2,0L558,650c-0.3-0.3-0.3-0.8,0-1.2l0,0c0.3-0.3,0.8-0.3,1.2,0 l2.5,2.5C562,651.7,562,652.2,561.7,652.5z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 533.6,
    y1: 679.9,
    x2: 544.4,
    y2: 667.9
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandIcon);
export default __webpack_public_path__ + "static/media/hand-icon.39817b19fb264b4020074557220de8fb.svg";
export { ForwardRef as ReactComponent };